import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { retrieveStockHistoryPrice, retrieveStockInfo } from "../../Services/StockSessionApiService";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Avatar } from "primereact/avatar";
import HistoryPriceStockData2 from "../../Components/PrimeReact/HistoryPrice/stock-data";
import HistoryPriceChart2 from "../../Components/PrimeReact/HistoryPrice/history-price";
import LogoHeader from "../../Components/PrimeReact/logoBanner";
import { useAuthHeader } from "../../auth/AuthService";
import { toLocalISOString } from "../../utils/DateUtils";

export default function HistoryPrice() {
    const [cookies, setCookie] = useCookies(['icode', 'bType', 'startDate', 'endDate']);
    const {t, i18n} = useTranslation();
    const [startDate, setStartDate] = useState(new Date(new Date().setMonth(new Date().getMonth() - 2)));
    const [endDate, setEndDate] = useState(new Date());
    const [price , setPrice] = useState([]);
    const [volume, setVolume] = useState([]);
    const [stock, setStock] = useState([]);
    const [currentStock, setCurrentStock] = useState({});
    const [mType, setMType] = useState(cookies.bType);
    const [icode, setIcode] = useState('');
    const boards = [
        { name: t('Main Board'), value: 'M' },
        { name: t('Growth Board'), value: 'G' },
    ];
    const [icodes, setIcodes] = useState([]);
    const authHeader = useAuthHeader();

    const onChangeMType = (e) => {
        let val = e.value;
        setMType(val);
        setCookie('bType', val);
    }
    
    const onChangeICode = (e) => {
        let val = e.value;
        setIcode(val);
        setCookie('icode', val);
    }

    const onChangeSDate = (e) => {
        setStartDate(e.value);
        setCookie('startDate', e.value);
    }

    const onChangeEDate = (e) => {
        setEndDate(e.value);
        setCookie('endDate', e.value);
    }

    async function getStock() {
        await retrieveStockInfo(cookies.bType, null, authHeader())
        .then((response) => {
            let data = response.data.data;
            let stock = response.data.data.stock;
            setStock(stock);
            if (!cookies.icode || !(data.issues.map((v) => v.icode).includes(cookies.icode))) { 
                if (mType == 'G') {
                    setCookie('icode', 'KH1000150008')
                    setIcode('KH1000150008');
                } else {
                    setCookie('icode', 'KH1000100003')
                    setIcode('KH1000100003');
                }
            } else {
                setIcode(cookies.icode);
            }
            setCurrentStock(data.stock.filter((stock) => stock.icode == icode)[0]);
            let icodes = data.stock.sort(function(a, b) {
                if (a.isymbol < b.isymbol) return -1;
                if (a.isymbol > b.isymbol) return 1;
                return 0;
            }).map((v) => ({'name': v.isymbol, 'value': v.icode}));
            setIcodes(icodes);
        })
        .catch((error) => console.log(error));
    }

    async function getPriceHistory() {
        mType && icode && await retrieveStockHistoryPrice(mType, icode, startDate, toLocalISOString(endDate), authHeader())
        .then((response) => {
            let data = response.data.data;
            let price = [];
            let volume = [];
            data.map((v) => {
                v[0] = (new Date(v[0])).getTime();
                if (v[6] == 2) {
                    v[1] = v[2] = v[3] = v[4];
                }
                price.push([
                    v[0],
                    v[1] == 0 ? v[4] : v[1],
                    v[2] == 0 ? v[4] : v[2],
                    v[3] == 0 ? v[4] : v[3],
                    v[4]
                ]);
                volume.push([v[0], v[5]]);
            });
            setPrice(price);
            setVolume(volume);
        })
        .catch((error) => console.log(error));
    }

    function init() {
        let date = new Date();
        !cookies.bType && setCookie('bType', 'M')
        if (cookies.startDate) {
            setStartDate(new Date(cookies.startDate));
        } else {
            let sDate = new Date(date.setMonth(date.getMonth() - 2));
            setStartDate(sDate);
            setCookie('startDate', sDate);
        }
        if (cookies.endDate) {
            setEndDate(new Date(cookies.endDate))
        } else {
            setStartDate(new Date());
            setCookie('endDate', new Date());
        }

        getStock();
    }

    useEffect(() => {
        getPriceHistory();
    }, [icode, startDate.toISOString(), endDate.toISOString(), i18n.language]);

    useEffect(() => {
        init();
    }, [mType])

    const icodeOptionTemplate = (option) => {
        return (
            <div className="flex align-items-center">
                <Avatar image={`/img/issue_logo_icons/${option?.value}_logo.jpg`} shape="circle"/>
                &nbsp;&nbsp;<div>{option.name}</div>
            </div>
        );
    };
    const selectedIcodeTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                   { option?.value ? <Avatar image={`/img/issue_logo_icons/${option?.value}_logo.jpg`} shape="circle"  className="absolute"/> : ''}
                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<div>{option.name}</div>
                </div>
            );
        }
        return <span>{props.placeholder}</span>;
    };
    const selectedBoardTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                   <div>{option.name}</div>
                </div>
            );
        }
        return <span>{props.placeholder}</span>;
    };

    return (
        <>
            <LogoHeader />
            <div className='col-12 -mt-3'>
                {/* <div className="flex align-items-center justify-content-start mb-2">
                    <span className="text-4xl font-bold">{t('Historical Price')}</span>
                </div> */}
                <div className="card p-4 shadow-3 border-round-lg bg-card">
                    <div className='grid mb-4'>
                        <div className='col-6 md:col-3'>
                            <Dropdown value={mType} onChange={onChangeMType} options={boards} valueTemplate={selectedBoardTemplate} optionLabel="name" placeholder="Select a Board" className="w-full border-round-lg"/>
                        </div>
                        <div className='col-6 md:col-3'>
                            <Dropdown value={icode} onChange={onChangeICode} options={icodes} valueTemplate={selectedIcodeTemplate} itemTemplate={icodeOptionTemplate} optionLabel="name" placeholder="Select a Stock" className="w-full border-round-lg"/>
                        </div>
                        <div className='col-6 md:col-3'>
                            <Calendar value={startDate} onChange={onChangeSDate} showIcon className="w-full border-round-lg"/>
                        </div>
                        <div className='col-6 md:col-3'>
                            <Calendar value={endDate} onChange={onChangeEDate} showIcon className="w-full border-round-lg"/>
                        </div>
                    </div>
                    <HistoryPriceStockData2
                        mtype = {mType}
                        icode = {icode}
                        lang={i18n.language}
                        stock={currentStock}
                    />
                    <HistoryPriceChart2
                        price={price}
                        volume={volume}
                        label = {{'title': t('Historical Price'), 'volume': t('Volume'), 'price': t('Price')}}
                    />
                </div>
            </div>
        </>
    );
}